import React, {
  createContext,
  useCallback,
  useReducer,
} from "react";
import { useNavigate } from "react-router-dom";
import { AuthActionEnum } from "./authAction";
import authReducer, { AuthState, defaultAuthState } from "./authReducer";
import { UserData } from "../../types/user-data.type";

type AuthProviderProps = {
  children: React.ReactElement;
};


export interface AuthContext {
  authState: AuthState;
  globalLogInDispatch: (props: UserData) => void;
  globalLogOutDispatch: () => void;
}


// Auth context
const authCtx = createContext<AuthContext>({
  authState: defaultAuthState,
  globalLogInDispatch: () => { },
  globalLogOutDispatch: () => { },
});

export const AuthContextProvider = (props: AuthProviderProps) => {
  const { children } = props;

  const [authState, authDispatch] = useReducer(authReducer, defaultAuthState);
  const navigate = useNavigate();

  const globalLogInDispatch = useCallback(
    (props: UserData) => {
      const { authToken, username, name, userId, roles, groups } = props;
      authDispatch({
        type: AuthActionEnum.LOG_IN,
        payload: {
          authToken,
          userId,
          name,
          username,
          roles,
          groups
        },
      });
      if (roles.includes("Admin"))
        navigate("/admin/insurances");
      else
        navigate("/portal");

    },
    [navigate]
  );

  const globalLogOutDispatch = useCallback(() => {
    authDispatch({ type: AuthActionEnum.LOG_OUT, payload: null });
    navigate("/login");
  }, [navigate]);

  // context values to be passed down to children
  const ctx = {
    authState,
    globalLogInDispatch,
    globalLogOutDispatch,
  };

  return <authCtx.Provider value={ctx}>{children}</authCtx.Provider>;
};

export default authCtx;